import api from 'api';
import { createSlice } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { IClientUser } from './userSlice';
import { IOrganizationDetails } from './organizationSlice';
import { IAddress } from 'helpers/types';
import { IRoles } from './administratorRoleSlice';

interface IProfileData {
  user_details: IClientUser;
  role_details: {
    merchant_detail: {
      partner_id: string;
      private_key: string;
    };
    orgDetails: IOrganizationDetails;
    parkings: IAddress[];
    roleDetails: Omit<IRoles, 'value' | 'id'>;
  }[];
}

interface IUserState {
  profileData: IProfileData | null;
}
const initialState: IUserState = {
  profileData: null,
};
const profileSlice = createSlice({
  name: 'Profile',
  initialState: initialState,
  reducers: {
    setProfileData: (state, { payload }: { payload: IProfileData }) => {
      state.profileData = payload;
    },
  },
});

export const getProfileData = (payload: { user_id: string }) => async (dispatch: Dispatch) => {
  try {
    const { user_id } = payload;
    const { data: responseData } = await api.get(`/admin/org/user/${user_id}`);
    dispatch(setProfileData(responseData?.data));
    return Promise.resolve(responseData?.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
export const { setProfileData } = profileSlice.actions;
export default profileSlice.reducer;
